function getUniqueArray(arr, key) {
    if (typeof arr === "object" && key) {
        const newArr = [];
        arr.forEach((item) => {
            if (!newArr.find((a) => a[key] === item[key])) {
                newArr.push(item);
            }
        });
        return newArr;
    }
    else {
        return [...new Set(arr)];
    }
}

export { getUniqueArray };
//# sourceMappingURL=getUniqueArray.js.map
